export const deadlinesQueryKeys = {
  all: ['deadlines'] as const,
  expected: (page: number, assigneeUserId = '', domain = '') =>
    ['deadlines', 'expected', page, assigneeUserId, domain] as const,
  filtered: (filter: {
    bucket: string;
    dueFrom: string;
    dueTo: string;
    q: string;
    assigneeUserId: string;
    domain: string;
    page: number;
  }) =>
    [
      'deadlines',
      'filtered',
      filter.bucket,
      filter.dueFrom,
      filter.dueTo,
      filter.q,
      filter.assigneeUserId,
      filter.domain,
      filter.page,
    ] as const,
  assigneeCandidates: () => ['deadlines', 'assignee-candidates'] as const,
  validitySuggestion: (documentTypeId: string) =>
    ['deadlines', 'validity-suggestion', documentTypeId] as const,
  detail: (deadlineId: string) => ['deadlines', 'detail', deadlineId] as const,
  sameTypeSummary: (documentTypeId: string, assigneeUserId = '') =>
    ['deadlines', 'same-type-summary', documentTypeId, assigneeUserId] as const,
};
